export default __webpack_public_path__ + "static/pokeballsleep-124073befde5bd7c85e982e53c58fed3.png";